import React, { useEffect, useRef } from "react";
import { useMapContext } from "./MapProvider";
import "./MapView.scss";
/**
 * Renders the target view for the `ol/Map`. Only one can be present in each
 * `<MapProvider>` sub-tree.
 *
 * Children of this component will be rendered in the map view overlay,
 * allowing easy placement of controls in the map area.
 */
export default function MapView({ children, className, background = "white", width = "100%", height = "100%", staticSize = false, }) {
    const ref = useRef(null);
    const { map, view, initialExtent } = useMapContext();
    useEffect(() => {
        if (!ref.current)
            return;
        map.setTarget(ref.current);
        if (initialExtent) {
            view.fit(initialExtent);
        }
    }, [map, view, initialExtent]);
    useEffect(() => {
        const el = ref.current;
        if (staticSize || !el)
            return;
        let w = el.clientWidth;
        let h = el.clientHeight;
        const iId = setInterval(() => {
            if (w !== el.clientWidth || h != el.clientHeight) {
                w = el.clientWidth;
                h = el.clientHeight;
                map.updateSize();
            }
        }, 200);
        return () => clearInterval(iId);
    }, [ref, staticSize, map]);
    return (React.createElement("div", { className: `map-view ${className !== null && className !== void 0 ? className : ""}`, style: { width, height, background } },
        React.createElement("div", { className: "map-view--map", ref: ref }),
        React.createElement("div", { className: "map-view--overlay" }, children)));
}
